export default __webpack_public_path__ + "static/media/whatittakes.8320bbf1.png";